import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AbstractDashboardDetailsService } from '../abstraction/abstract.dashboard-details.service';
import { IFedNowDetails } from '../../interfaces/fednow-details.interface';
import { IRtpDetails } from '../../interfaces/rtp-details.interface';
import { lastValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class MockDashboardDetailsService extends AbstractDashboardDetailsService {
  private getRtpDetailsJson = 'assets/mocks/dashboard/getRtpDetails.json';
  private getFedNowDetailsJson = 'assets/mocks/dashboard/getFednowDetails.json';
  constructor(private http: HttpClient) {
    super();
  }

  override getFedNowDetails(): Promise<IFedNowDetails | undefined> {
    return lastValueFrom(this.http.get<IFedNowDetails>(this.getFedNowDetailsJson));
  }
  override getRtpDetails(): Promise<IRtpDetails | undefined> {
    return lastValueFrom(this.http.get<IRtpDetails>(this.getRtpDetailsJson));
  }
}
